import React, {Fragment, useEffect, useState} from 'react';
import Box from '../layout/Box';
import {postData, UrlGenerator} from "../../utils/request";
import Button from "../form/Button";
import BoxEditor from "./BoxEditor";
import ShippingTourList from "./lists/ShippingTourList";
import ShippingTourForm from "./forms/ShippingTourForm";
import ComponentEditor, {referenceActionData} from "../form/ComponentEditor/ComponentEditor";
import {validations} from "../form/ComponentEditor/Validation";
import {empty} from "locutus/php/var";
import Confirm from "../form/Confirm";
import CodeScanner from "../form/CodeScanner";
import {loadComponent} from "../../utils/components";
import moment from "moment/moment";

class ShippingTourEditor extends React.Component {

    form = React.createRef();

    state = {
        selectedGroupage: null,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.props.setFormValues({
            name: moment().format("YYYYMMDDHHmm"),
            groupages: [],
        });
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    setSelectedGroupage = (selectedGroupage) => {
        this.setState({
            selectedGroupage
        })
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        
        return (
            <Fragment>
                <List 
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Túra lista"
					footer={[
                        <this.props.newButton
                            key="0"
                            pristineForm={this.pristineForm}
                        >
                            Új
                        </this.props.newButton>,
                        <CodeScanner
                            onlyScanner={true}
                            label={false}
                            saveChanges={(field, value) => {
                                if (value && value.includes("#")) {
                                    const [component, id] = value.split("#");
                                    if (component === this.props.componentConfig.componentname) {
                                        this.props.setContent(component, {[this.props.componentConfig.idfield]: id});
                                    } else if (component === "Groupage") {
                                        loadComponent("Groupage", {id},["id","tracking_id","order_date","state","origin","destination","partner"]).then((groupage) => {
                                            loadComponent(this.props.componentConfig.componentname, {filter: {field: "groupages", value: id}}).then((component) => {
                                                this.props.setContent(this.props.componentConfig.componentname, {[this.props.componentConfig.idfield]: component[this.props.componentConfig.idfield]});
                                                this.setSelectedGroupage(groupage);
                                            });
                                        });
                                    }
                                }
                            }}
                        />
					]}
                >
                    <ShippingTourList
                        ref={(el) => this.list = el}
                        {...this.props}
                    />
                </List>
                <Editor
                    {...this.props}
                    theme="default"
                    header="Túra adatai"
					footer={[
						this.props.values[this.props.componentConfig.idfield] ? 
                        (
                            <Fragment key="actions">
                                {
                                    parseInt(this.props.values.state || "0") === 0
                                        ?
                                        <Confirm
                                            key="4"
                                            className="pull-right"
                                            header="Biztos elindítod?"
                                            body="Biztos elindítod?"
                                            color="primary"
                                            onAccept={async () => {
                                                await this.props.processAction(async () => {
                                                    return await postData({
                                                        action: 'ShippingTour.proceedState',
                                                        id: this.props.values[this.props.componentConfig.idfield],
                                                    });
                                                });
                                                this.form?.current?.groupages?.current?.refresh();
                                                this.props.reloadForm();
                                            }}
                                        >
                                            Túra inditása
                                        </Confirm>
                                        :
                                        null
                                }
                                {parseInt(this.props.values.state || "0") !== 0 ? <Button
                                    className="pull-right"
                                    onClick={() => {
                                        let url = UrlGenerator();
                                        delete url.fragment;
                                        url.query = {
                                            option: this.props.componentConfig.componentname,
                                            [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                            resptype: "pdf"
                                        };
                                        window.open(url.toString(), '_blank');
                                    }}
                                    color="default"
                                >
                                    Túralevél
                                </Button> : null}
                                {
                                    parseInt(this.props.values.state || "0") === 0 ? <this.props.deleteButton
                                        key="delete"
                                    /> : null
                                }
                            </Fragment>
                        )
                        :
                        <this.props.saveButton
                            key="save"
                            saveForm={this.saveForm}
                        >
                            Túra létrehozása
                        </this.props.saveButton>,
                    ]}
                >
                    <ShippingTourForm
                        ref={this.form}
                        {...this.props}
                        setSelectedGroupage={this.setSelectedGroupage}
                        selectedGroupage={this.state.selectedGroupage}
                    />
                </Editor>
            </Fragment>
        );
    }
}

const actionValidation = async ({data, componentConfig, action}) => {
    if (action === "create") {
        let messages = null;
        messages = await validations(
            messages,
            data,
            [
                {
                    field: "name",
                    validation: ({value}) => !empty(value),
                    type: ({valid}) => valid ? "valid" : "error",
                    message: ({valid}) => !valid ? "Kérlek töltsd ki!" : true
                },
                {
                    field: "groupages",
                    validation: ({value}) => !empty(value),
                    type: ({valid}) => valid ? "valid" : "error",
                    message: ({valid}) => !valid ? "Legalább egy gyűjtőt válassz ki!" : true
                },
            ]
        );
        return messages;
    }
}

export default (props) => {
    return <ComponentEditor
        componentName="ShippingTour"
        actionValidation={actionValidation}
        saveForm={async ({requestData, componentConfig}) => {
            requestData.data = await referenceActionData(requestData.data, componentConfig);
            return postData(requestData);
        }}
        {...props}
    >
        <ShippingTourEditor />
    </ComponentEditor>;
}